import { atom } from "@mongez/react-atom";
import type { PaginationInfo } from "core/shared/types";
import { Order } from "../types";

export type OrdersAtom = {
  orders: Order[];
  isLoadingMore: boolean;
  paginationInfo: PaginationInfo;
};

export const ordersAtom: any = atom<OrdersAtom>({
  key: "orders",
  default: {},
});

export const orderAtom: any = atom<Order>({
  key: "order",
  default: {},
});
